import React, { Component } from 'react';
import PropTypes from "prop-types";
import addImagesBgSvg from './add-images-bg.svg';
import './add-images.scss';

class AddImages extends Component {
  constructor() {
    super();
    this.acceptTypes = ['image/png', 'image/jpeg', 'image/gif']
    this.state = {
      images: [],
    }
  }

  bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }

  changedImages = (e) => {
    const errors = [];
    const images = Array.from(e.target.files)

    images.forEach((image) => {

      if (this.acceptTypes.indexOf(image.type) === -1) {
        errors.push(`'${image.name}': ${image.type}' is not a supported format`);
        return;
      }

      if (image.size > this.props.maxSize) {
        errors.push(`'${image.name}': is too large. Image should be less than ${this.bytesToSize(this.props.maxSize)}`);
        return;
      }
    })

    if (errors.length) {
      this.props.onError(errors)
      return;
    }
    Promise.all(images.map(this.convertImageToBase64))
      .then((base64Images) => {
        this.props.onUpload(base64Images);
        this.setState({
          errors: [],
        });
      });
  }

  convertImageToBase64 = (imgFile) => {
    return new Promise((res, rej) => {
      var reader = new FileReader();
      reader.onloadend = function () {
        res(reader.result);
      };
      reader.onerror = function() {
        rej();
      }
      reader.readAsDataURL(imgFile);
    });
  }


  getErrorsHint = (errors) => {
    return errors.map((error) => {
      return (<span key={error}>{error}</span>)
    })
  }

  onImgDeleteClick = (e) => {
    this.props.onDeleteImgByIndex(+e.target.attributes['data-index'].value);
  }

  render() {
    return (
      <div className='project-image-wrapper'>
        {
          this.props.images.map((image, index) => {
            return (
              <div key={image + index}>
                <div className="image-delete">
                  <span className="image-delete-cross" data-index={index} onClick={this.onImgDeleteClick}>&#10006;</span>
                </div>
                <div className="project-img" style={{backgroundImage: `url(${image})`}}></div>
              </div>
            );
          })
        }
        <div className="add-images-wrapper">
          <label htmlFor='images-selector'>
            <img src={addImagesBgSvg} alt="Add-images button background"/>
          </label>
          <input id="images-selector" onChange={this.changedImages} type='file' multiple accept={this.acceptTypes.join(', ')}/>
        </div>
        {!!this.props.errors.length &&
          <div className="errors-hints">
            Not valid users:
                {this.getErrorsHint(this.props.errors)}
          </div>
        }
      </div>
    );
  }
}

AddImages.propTypes = {
  maxSize: PropTypes.number.isRequired,
  images: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onDeleteImgByIndex: PropTypes.func.isRequired,
}

export default AddImages;


// WEBPACK FOOTER //
// ./src/components/AddProject/AddImages/index.js